module.exports = __webpack_public_path__ + "static/media/tiktok-app-oauth.99b34adb.png";